module.exports = __webpack_public_path__ + "static/img/20190930.7fa5b9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/qiye/20190930.png
// module id = XNEF
// module chunks = 1